import { cn } from '../lib/cn';

export interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  tight?: boolean;
  as?: 'div' | 'section' | 'article' | 'aside';
}

export function Panel({
  tight,
  as: Tag = 'div',
  className,
  children,
  ...rest
}: PanelProps): React.JSX.Element {
  return (
    <Tag className={cn(tight ? 'lk-panel-tight' : 'lk-panel', className)} {...rest}>
      {children}
    </Tag>
  );
}

export interface StatProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  icon?: React.ReactNode;
  tone?: string;
  className?: string;
}

/** Плитка показника: велика цифра, дрібний підпис. */
export function Stat({ label, value, hint, icon, tone, className }: StatProps): React.JSX.Element {
  return (
    <div className={cn('lk-panel-tight flex flex-col gap-1 px-3 py-3', className)}>
      <div className="flex items-center gap-1.5 text-[11px] font-black tracking-wide text-white/60 uppercase">
        {icon}
        <span>{label}</span>
      </div>
      <div className="tabular text-2xl leading-none font-black" style={tone ? { color: tone } : undefined}>
        {value}
      </div>
      {hint ? <div className="text-xs font-semibold text-white/55">{hint}</div> : null}
    </div>
  );
}

export interface MeterProps {
  value: number;
  max?: number;
  className?: string;
  from?: string;
  to?: string;
  label?: string;
}

export function Meter({
  value,
  max = 1,
  className,
  from,
  to,
  label,
}: MeterProps): React.JSX.Element {
  const pct = Math.max(0, Math.min(100, (value / (max || 1)) * 100));
  return (
    <div
      className={cn('lk-meter', className)}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <i
        style={{
          width: `${pct}%`,
          ...(from && to ? { background: `linear-gradient(90deg, ${from}, ${to})` } : {}),
        }}
      />
    </div>
  );
}
